import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import CONFIG from "../../config";
import "./RespuestasAutomaticas.css";

export default function RespuestasAutomaticas({ onBack }) {
  const [respuestas, setRespuestas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({ id: null, palabra_clave: "", respuesta: "", imagenes: [] });
  const [subiendo, setSubiendo] = useState(false);

  const URL_ACTUALIZAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Actualizar-respuesta-LaPile";
  const URL_ANEXAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Nueva-respuesta-LaPile";
  const URL_ELIMINAR = "https://nonsyntactic-intestinal-nita.ngrok-free.dev/webhook/Eliminar-respuesta-LaPile";

  const cargarRespuestas = () => {
    axios
      .get(`${CONFIG.API_URL}respuestas_automaticas.php`, { withCredentials: true })
      .then((res) => {
        if (res.data.ok) {
          setRespuestas(res.data.data || []);
        }
      })
      .catch(() => {
        Swal.fire("Error", "No se pudieron cargar las respuestas", "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    cargarRespuestas();
  }, []);

  const abrir = (item) => {
    setForm({
      id: item.id ?? null,
      palabra_clave: item.palabra_clave ?? "",
      respuesta: item.respuesta ?? "",
      imagenes: item.imagenes ?? [],
    });
    setModal(true);
    setEditando(false);
  };

  const cerrar = () => setModal(false);

  const enviarAN8N = async (url, payload) => {
    try {
      await fetch(url, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error("Error enviando a n8n:", error);
    }
  };

  const subirImagen = async (file) => {
    setSubiendo(true);
    try {
      const formData = new FormData();
      formData.append("imagen", file);
      const res = await axios.post(`${CONFIG.API_URL}subir_imagen.php`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.ok) {
        setForm((prev) => ({
          ...prev,
          imagenes: [...prev.imagenes, res.data.url],
        }));
      } else {
        Swal.fire("Error", res.data.message || "Error al subir imagen", "error");
      }
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "Error al subir imagen", "error");
    } finally {
      setSubiendo(false);
    }
  };

  const agregarUrlExterna = () => {
    Swal.fire({
      title: "Agregar URL externa",
      input: "url",
      inputPlaceholder: "https://ejemplo.com/imagen.jpg",
      showCancelButton: true,
      confirmButtonText: "Agregar",
      cancelButtonText: "Cancelar",
      preConfirm: (url) => {
        if (!url) {
          Swal.showValidationMessage("Ingresá una URL válida");
        }
        return url;
      },
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        setForm((prev) => ({
          ...prev,
          imagenes: [...prev.imagenes, result.value],
        }));
      }
    });
  };

  const eliminarImagen = (index) => {
    setForm((prev) => ({
      ...prev,
      imagenes: prev.imagenes.filter((_, i) => i !== index),
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => subirImagen(file));
    e.target.value = "";
  };

  const guardar = () => {
    if (!form.palabra_clave.trim() || !form.respuesta.trim()) {
      Swal.fire("Error", "Completa todos los campos", "warning");
      return;
    }

    const esEdicion = !!form.id;

    Swal.fire({
      title: esEdicion ? "¿Actualizar respuesta?" : "¿Guardar respuesta?",
      text: esEdicion
        ? "Se actualizará la base de datos y se enviará a n8n."
        : "Se guardará la respuesta nueva y se enviará a n8n.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: esEdicion ? "Sí, actualizar" : "Sí, guardar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      cerrar();

      const payload = {
        id: form.id,
        palabra_clave: form.palabra_clave,
        respuesta: form.respuesta,
        imagenes: form.imagenes,
      };

      axios
        .post(`${CONFIG.API_URL}respuestas_automaticas.php`, payload, { withCredentials: true })
        .then((res) => {
          if (!res.data.ok) {
            throw new Error(res.data.message || "Error al guardar");
          }

          const n8nPayload = {
            id: res.data.data?.id ?? form.id,
            palabra_clave: form.palabra_clave,
            respuesta: form.respuesta,
            imagenes: form.imagenes,
            accion: esEdicion ? "actualizar" : "anexar",
          };

          const urlN8N = esEdicion ? URL_ACTUALIZAR : URL_ANEXAR;

          return enviarAN8N(urlN8N, n8nPayload).then(() => {
            Swal.fire(
              "Listo",
              esEdicion ? "Respuesta actualizada y enviada" : "Respuesta agregada y enviada",
              "success"
            );
            cargarRespuestas();
            setEditando(false);
          });
        })
        .catch((err) => {
          Swal.fire("Error", err.message || "Error al guardar", "error");
        });
    });
  };

  const eliminar = (id) => {
    const itemAEliminar = respuestas.find((r) => r.id === id);

    if (!itemAEliminar) {
      Swal.fire("Error", "No se encontró la respuesta", "error");
      return;
    }

    Swal.fire({
      title: "¿Eliminar respuesta?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      cerrar();

      axios
        .delete(`${CONFIG.API_URL}respuestas_automaticas.php`, { data: { id }, withCredentials: true })
        .then((res) => {
          if (!res.data.ok) {
            throw new Error(res.data.message || "No se pudo eliminar");
          }

          const payload = {
            id: itemAEliminar.id,
            palabra_clave: itemAEliminar.palabra_clave,
            respuesta: itemAEliminar.respuesta,
            imagenes: itemAEliminar.imagenes,
            accion: "eliminar",
          };

          return enviarAN8N(URL_ELIMINAR, payload).then(() => {
            Swal.fire(
              "Eliminado",
              "La respuesta fue eliminada y sincronizada con n8n",
              "success"
            );
            cargarRespuestas();
          });
        })
        .catch((err) => {
          Swal.fire("Error", err.message || "No se pudo eliminar", "error");
        });
    });
  };

  const nuevaRespuesta = () => {
    setForm({ id: null, palabra_clave: "", respuesta: "", imagenes: [] });
    setModal(true);
    setEditando(true);
  };

  return (
    <div className="respuesta-container">
      <div className="respuesta-header">
        <button className="back-btn" onClick={onBack}>
          ← Volver
        </button>
        <h2>⚡ Respuestas automáticas</h2>
        <button className="new-btn" onClick={nuevaRespuesta}>
          + Nueva respuesta
        </button>
      </div>

      {loading ? (
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando respuestas...</p>
        </div>
      ) : (
        <div className="respuesta-grid">
          {respuestas.map((r) => (
            <div key={r.id} className="respuesta-card" onClick={() => abrir(r)}>
              <span className="respuesta-keyword">🔑 {r.palabra_clave}</span>
              <p>{(r.respuesta || "").slice(0, 120)}...</p>
              {r.imagenes && r.imagenes.length > 0 && (
                <div className="respuesta-card-imagenes">
                  {r.imagenes.slice(0, 3).map((img, i) => (
                    <img key={i} src={img} alt="" className="respuesta-card-thumb" />
                  ))}
                  {r.imagenes.length > 3 && (
                    <span className="respuesta-card-mas">+{r.imagenes.length - 3}</span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {modal && (
        <div className="modal-overlay" onClick={cerrar}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={cerrar}>
              ✕
            </button>
            <h3>{form.id ? "✏️ Editar respuesta" : "📝 Nueva respuesta"}</h3>

            <input
              type="text"
              placeholder="Palabra clave"
              value={form.palabra_clave}
              onChange={(e) => setForm({ ...form, palabra_clave: e.target.value })}
            />
            <textarea
              placeholder="Respuesta automática..."
              value={form.respuesta}
              onChange={(e) => setForm({ ...form, respuesta: e.target.value })}
              rows={5}
            />

            <div className="imagenes-section">
              <label>Imágenes</label>
              <div className="imagenes-actions">
                <label className="upload-btn">
                  {subiendo ? "Subiendo..." : "📁 Subir imagen"}
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleFileChange}
                    hidden
                    disabled={subiendo}
                  />
                </label>
                <button className="url-btn" onClick={agregarUrlExterna}>
                  🌐 Agregar URL
                </button>
              </div>

              {form.imagenes.length > 0 && (
                <div className="imagenes-preview">
                  {form.imagenes.map((url, i) => (
                    <div key={i} className="imagen-preview-item">
                      <img src={url} alt={`Imagen ${i + 1}`} />
                      <button
                        className="imagen-remove"
                        onClick={() => eliminarImagen(i)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="modal-actions">
              <button className="save-btn" onClick={guardar}>
                Guardar
              </button>
              {form.id && (
                <button className="delete-btn" onClick={() => eliminar(form.id)}>
                  Eliminar
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
